import moment from 'moment'
import currency from 'currency.js'
import { decamelize } from 'humps'
import store from '@/store'

export const caclulateOffset = (page, limit) => (page - 1) * limit

export const calculateDatesByPeriod = period => {
  if (period === 'today') {
    return [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  } if (period === 'yesterday') {
    return [moment().subtract(1, 'day').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD')]
  } if (period === 'thisWeek') {
    return [moment().startOf('isoWeek').format('YYYY-MM-DD'), moment().endOf('isoWeek').format('YYYY-MM-DD')]
  } if (period === 'lastWeek') {
    return [moment().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD'), moment().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD')]
  } if (period === 'thisMonth') {
    return [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
  } if (period === 'lastMonth') {
    return [moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')]
  }

  return []
}
export const currencyFormat = (value, currencyCode) => {
  if (typeof value === 'undefined') {
    return ''
  }
  const val = value
  const symbol = ''

  if (currencyCode === 840) {
    // eslint-disable-next-line no-shadow
    const USD = value => currency(value)
    return USD(value).format()
  } if (currencyCode === 116) {
    // eslint-disable-next-line no-shadow
    const RIEL = value => currency(value, { precision: 2, symbol: '៛' })
    return RIEL(value).format()
  } if (currencyCode === 764) {
    // eslint-disable-next-line no-shadow
    const C = value => currency(value, { precision: 2, symbol: '฿' })
    return C(value).format()
  } if (currencyCode === 418) {
    // eslint-disable-next-line no-shadow
    const C = value => currency(value, { precision: 2, symbol: '₭' })
    return C(value).format()
  }

  return currency(value)
}
export const prepareSearchParams = (payload, filtertype = 'AND') => {
  const filterArr = []

  if (payload.searchFields) {
    payload.searchFields.forEach(item => {
      if (!item.skip) {
        if (payload[item.key] || false) {
          let search = payload[item.key]
          switch (item.cast) {
            case 'boolean':
              search = (search == 1)
              break
          }

          if (search && item.suffix) {
            search = `${search} ${item.suffix}`
          }

          filterArr.push({
            searchby: item.searchKey ? item.searchKey : decamelize(item.key),
            searchoperator: item.operator || '=',
            search,
          })
        }
      }
    })
  }
  const params = {
    limit: store.state.pagination.perPage,
    page: payload.page,
    sortby: payload.order || 'id',
    sort: payload.sort || 'desc',
    filtertype,
    filters: filterArr,
  }

  return params
}
export const preparePaginationParams = (payload, filtertype = 'AND') => {
  const params = {
    limit: store.state.pagination.perPage,
    page: payload.page,
    sortby: payload.order || 'id',
    sort: payload.sort || 'desc',
    filtertype,
    filters: [],
  }

  return params
}
